import React, { useContext } from "react";
import { CardHeading, CardWrapper } from "./Elements";
import { Icon } from "@iconify/react";
import { AosContext } from "../Context/AosContext";

const SectionCard = ({ data, dataAos }) => {
  return (
    <CardWrapper bg={data.bg} data-aos={dataAos}>
      <CardHeading>
        <Icon icon={data.icon} height="100" />
        <h4>{data.title}</h4>
      </CardHeading>

      <p>{data.desc}</p>
    </CardWrapper>
  );
};

export default SectionCard;
